var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.363604 1.6364C0.0121322 1.28492 0.0121322 0.715076 0.363604 0.363604C0.715076 0.012132 1.28492 0.012132 1.6364 0.363604L0.363604 1.6364ZM7 7L7.6364 6.3636L8.27279 7L7.6364 7.6364L7 7ZM1.6364 13.6364C1.28492 13.9879 0.715076 13.9879 0.363604 13.6364C0.0121322 13.2849 0.0121322 12.7151 0.363604 12.3636L1.6364 13.6364ZM1.6364 0.363604L7.6364 6.3636L6.3636 7.6364L0.363604 1.6364L1.6364 0.363604ZM7.6364 7.6364L1.6364 13.6364L0.363604 12.3636L6.3636 6.3636L7.6364 7.6364Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.bc03a2179e3a83962a578e6f6624f3c6.svg";
export { ForwardRef as ReactComponent };